import React, {useContext} from "react";
import {UsacmContext} from "../App";
import {getCourseEmails, updateCourseEmail} from "../api/CourseApi";
import {EmailTemplateEditor} from "../shared/EmailTemplateEditor";
import {CONF_LABEL_KEY_COURSE} from "../constants";
import {getConfLabel} from "../utils/usacmUtils";

/**
 * The emails sent to buyers - when Stripe says how a purchase's payment went, and when a purchase which needs
 * review is approved or denied.  Only course admins edit them (not instructors).
 */
export function CourseSettingsEmail() {
  const context = useContext(UsacmContext);
  const [conf,] = context.conference;
  const courseLabel = getConfLabel(conf, CONF_LABEL_KEY_COURSE);

  return (
      <EmailTemplateEditor
          loadTemplates={getCourseEmails}
          saveTemplate={updateCourseEmail}
          canEdit={true}
          intro={`You can edit the emails sent to buyers when a ${courseLabel} purchase is paid, is waiting for review, 
            has its payment declined, and when a purchase which needs review is approved or denied.`}
      />
  );
}
